import fixImageOrientation from './fixImageOrientation';

const dataURLtoFile = (dataurl, filename) => {
  let arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
  while(n--){
      u8arr[n] = bstr.charCodeAt(n);
  }
  const blob = new Blob([u8arr], {type:mime});
  blob.name = filename;
  return blob;
};

export default async (file, maxWidth, maxHeight, quality = 0.8, fileName = `${Date.now()}.jpeg`) => {
  return new Promise(async (resolve, reject) => {
    // Ensure file to be an image
    if (!/image.*/.test(file.type)) {
      return reject(new Error('File must be an image with mimetype image/*.'));
    }

    file = await fixImageOrientation(file);

    //Load image in FileReader
    const reader = new FileReader();
    reader.onload = (readerLoaded) => {
      const image = new Image();
      image.onload = (imageLoaded) => {
        // Resize the image
        const canvas = document.createElement('canvas');
        let width = image.width;
        let height = image.height;
        let ratio = 0;
        if (width > maxWidth) {
          ratio = maxWidth / width;
          height = height * ratio;
          width = width * ratio;
        }
        if (height > maxHeight) {
          ratio = maxHeight / height;
          width = width * ratio;
          height = height * ratio;
        }
        canvas.width = width;
        canvas.height = height;
        canvas.getContext('2d').drawImage(image, 0, 0, width, height);
        const dataUrl = canvas.toDataURL('image/jpeg', quality);
        const resized = dataURLtoFile(dataUrl, fileName);
        return resolve(resized);
      };
      image.src = readerLoaded.target.result;
    };
    reader.readAsDataURL(file);
  });
};



// WEBPACK FOOTER //
// ./src/helpers/imageResizer.js